import { isValidArray } from "src/Library/Helper";
import { getShippers, fetchOrganisationFFGroups, fetchLinkedFFs } from "src/api/masters";
import { message } from "antd";
import { fetchAllTeams, searchTeam } from "src/api/teams";
import { InquiryModes } from "src/Library/Constants";

const { FCL, LCL, AIRCARGO } = InquiryModes;
const routeOptions = [
  { key: 'DIRECT', label: 'Direct'},
  { key: 'TRANSSHIPMENT', label: 'Transshipment'},
];

const criteriaTypes = [
  { key: 'SINGLE', label: 'Single' },
  { key: 'MULTIPLE', label: 'Multiple' },
];

const portType = [
  { key: 'PORT_NAME', label: 'Port Name', airLabel: 'Air Port' },
  { key: 'COUNTRY', label: 'Country' },
];

const shippersCheckbox = [
  { key: 'isApplicableForNonLinkedShippers', label: 'Non Linked Shippers'},
  { key: 'isApplicableForAllLinkedShippers', label: 'All Linked Shippers'},
];

const shipperTeamsCheckBoxes = [
  { key: 'isApplicableToAllShipperTeams', label: 'All Shippers' },
];

const markupType = [
  { key: 'USD', label: 'USD' },
  { key: 'Percentage', label: '%' },
];

const actionIcons = [
  { key: 'edit', label: 'Edit' },
  { key: 'user-add', label: 'Assign Shipper' },
  { key: 'copy', label: 'Duplicate' },
  { key: 'delete', label: 'Delete' },
];

const fetchedDataKeys = [
  'cargoList', 'carriers', 'containerList', 'podCountries', 'polCountries', 'pods', 'pols', 'ffOrganisations', 'rateSource'
];

const allLinkedShippersText = `This includes all those shippers also who will be linked in
  future.`;

export const allShippersText = `including upcoming shippers`;

const fetchShippersAndGroups = async (queryString, linkedShippers, groups) => {
  let shippersFetched : any [] = [];
  let apiArray;
  let groupList = groups;
  if (!isValidArray(linkedShippers)) {
    apiArray = [
      getShippers({ queryString }),
      fetchOrganisationFFGroups({}),
    ];
  } else {
    apiArray = [getShippers({ queryString })];
  }
  const responses : any = await Promise.all(apiArray);
  responses?.forEach((response, index) => {
    if (!response.isSuccess) {
      message.error(response.errorMessage);
    }
    if (isValidArray(response.data)) {
      if (index !== 0) {
        groupList = response.data.map((item) => {
          return {
            key: item.id,
            label: item.name,
            isGroup: true,
        }});
      } else {
        shippersFetched = response.data.map((item) => {
          return {
            key: item.id,
            label: item.name,
        }});
    }}
    shippersFetched = [...shippersFetched, ...groupList];
  });
  return { shippersFetched, groupList};
}

const fetchVendorsAndTeams = async (queryString, teams, vendors) => {
  let vendorsFetched = vendors, teamsFetched = [], apiArray;
  if (!isValidArray(teams)) {
    apiArray = [
      searchTeam({ ...queryString }),
      fetchLinkedFFs({}),
    ];
  } else {
    apiArray = [searchTeam({ ...queryString })];
  }
  const responses : any = await Promise.all(apiArray);
  responses?.forEach((response, index) => {
    if (!response.isSuccess) {
      message.error(response.errorMessage);
    }
    if (isValidArray(response.data)) {
      if (index !== 0) vendorsFetched = response.data.map(({id, name}) => ({ id, name }));
      else teamsFetched = response.data.map(({id, name}) => ({ id, name }));
    }
  });
  return { vendors: vendorsFetched, teams: teamsFetched};
}

const markupFilters = [
  { key: 'ALL', label: 'All' },
  { key: 'EXPIRED', label: 'Expired' },
  { key: 'ACTIVE', label: 'Active' },
  { key: 'INACTIVE', label: 'Inactive' },
];

export const markupRuleRangeMap = {
  containerCount: {start: 'containerRangeStart', end: 'containerRangeEnd'},
  grossWeight: {start: 'grossWeightStart', end: 'grossWeightEnd'},
}

export const rateSource = [{ id: 'RFQ', name: 'RFQ' }, { id: 'INQUIRY', name: 'INQUIRY' }]

export const shippingModes = { FCL, LCL, AIR: AIRCARGO }

export const modeWiseUnit = {
  FCL: 'container',
  LCL: 'cbm',
  AIRCARGO: 'kg'
}

export {
  routeOptions,
  criteriaTypes,
  portType,
  shippersCheckbox,
  markupType,
  actionIcons,
  allLinkedShippersText,
  fetchedDataKeys,
  fetchShippersAndGroups,
  markupFilters,
  shipperTeamsCheckBoxes,
  fetchVendorsAndTeams
}
